<template>
  <div class="field-group">
    <div v-if="group.name">
      <div class="field-group-divider" v-on:click="toggleIsExpanded">
        <span class="group-name">{{ group.name }}</span>
        <span class="group-subtitle">{{ group.subtitle }}</span>
        <span class="group-fill"></span>
        <span class="fa" :class="{ 'fa-chevron-down': !isExpanded, 'fa-chevron-up': isExpanded }"></span>
      </div>
      <transition name="fade">
        <div v-if="isExpanded" class="field-group-list">
          <slot></slot>
        </div>
      </transition>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    group: {
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: -1,
    },
  },
  data: function() {
    return {
      isExpanded: this.group.isExpanded
    }
  },
  watch: {
    group: function(newValue) {
      this.isExpanded = newValue.isExpanded;
    }
  },
  methods: {
    toggleIsExpanded: function() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../_css/variables";

.field-group-divider {
  border-bottom: 1px solid $gray-500;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: $gray-600;
  padding: 0.3em 1em;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  & > .group-name {
    font-size: 0.75rem;
    font-weight: bold;
  }

  & > .group-subtitle {
    font-size: 0.75rem;
    margin-left: 0.5em;
    color: $brand-700;
    font-weight: bold;
  }

  & > .group-fill {
    flex: 1 0 auto;
  }
}

.field-group-list {
  border-bottom: 1px solid $gray-500;
}

.field-group-list:last-child {
  border-bottom: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
